// ==========================================
// 1. PROMOTION CONFIGURATION (Easy to switch)
// ==========================================
const PROMO_CONFIGs = {
  steps: [
    { 
      id: 'strap', 
      navTitle: 'Straps', 
      headerTitle: 'SELECT 2 FREE STRAPS', 
      limit: 2, 
      dataKey: 'merged_straps',
      target_collection_handle: 'straps'
    },
    { 
      id: 'purse', 
      navTitle: 'Coin purse', 
      headerTitle: 'SELECT 1 FREE COIN PURSE', 
      limit: 1, 
      dataKey: 'merged_purses',
      target_collection_handle: 'coin-purse' // Ensure this matches your actual collection handle
    }
  ]
};

// ==========================================
// 2. GLOBAL STATE & DATA FETCHING
// ==========================================
window.modalData = {
  merged_straps: [],
  merged_purses: []
};
let userSelections = {}; 
let currentStepIndex = 0;

function setBundleIdField(value) {
  let bundleInput = document.getElementById('dynamic_bundle_id');
  if (!bundleInput) {
    bundleInput = document.createElement('input');
    bundleInput.type = 'hidden';
    bundleInput.id = 'dynamic_bundle_id';
    document.body.appendChild(bundleInput);
  }
  bundleInput.value = value;
}

function resetBundleIdField() {
  let bundleInput = document.getElementById('dynamic_bundle_id');
  if (!bundleInput) {
    bundleInput = document.createElement('input');
    bundleInput.type = 'hidden';
    bundleInput.id = 'dynamic_bundle_id';
    document.body.appendChild(bundleInput);
  }
  bundleInput.value = Date.now();
}

function getBundleId() {
  const currentBundleId = document.getElementById('dynamic_bundle_id').value;
  return currentBundleId;
}
document.addEventListener('DOMContentLoaded', resetBundleIdField);

// Utility to merge arrays and remove duplicates (keeps featured first)
function deduplicateAndMerge(featuredArray, allArray) {
  const seen = new Set();
  const merged = [];
  
  [...(featuredArray || []), ...(allArray || [])].forEach(item => {
    if (!seen.has(item.id)) {
      seen.add(item.id);
      merged.push(item);
    }
  });
  return merged;
}

async function fetchStrapData(handle) {
  try {
    const url = handle ? `/products/${handle}?sections=product-customization-straps-list` : `${window.location.pathname}?sections=product-customization-straps-list`;
    const response = await fetch(url);
    const data = await response.json();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data['product-customization-straps-list'], 'text/html');
    const jsonScript = doc.getElementById('strap-upsell-data');

    if (jsonScript) {
      const rawData = JSON.parse(jsonScript.textContent);
      
      window.modalData.merged_straps = deduplicateAndMerge(rawData.featured_straps, rawData.all_straps);
      window.modalData.merged_purses = deduplicateAndMerge(rawData.featured_purses, rawData.all_purses);

      if (window.modalData.merged_straps.length === 0) {
        fallbackToCart();
      } else {
        openDynamicModal(); 
      }
    } else {
      console.error("Could not find JSON in the returned section.");
      fallbackToCart();
    }
  } catch (error) {
    console.error("Error fetching modal data:", error);
    fallbackToCart();
  }
}

function fallbackToCart() {
  if (typeof theme !== 'undefined' && theme.CartDrawer) {
    var cart = new theme.CartDrawer;
    if(cart.init) cart.init();
    if(cart.open) cart.open(); 
  }
}

// ==========================================
// 3. STOREFRONT API INTEGRATION (NEW)
// ==========================================

async function getAllProducts(collectionHandle) {
  let page = 1;
  const products = [];
  const rootUrl = window.Shopify?.routes?.root || '/';

  while (true) {
    // 250 is the maximum limit per page for products.json
    const url = `${rootUrl}collections/${collectionHandle}/products.json?limit=250&page=${page}`;
    
    try {
      const response = await fetch(url);
      const data = await response.json();

      // If the page returns no products, we've reached the end of the collection
      if (!data.products || data.products.length === 0) {
        break;
      }

      data.products.forEach(product => {
        // Find the first variant that is actually available for sale
        const availableVariant = product.variants.find(v => v.available);
        
        // Skip if the product is completely out of stock
        if (!availableVariant) return;

        const numericId = availableVariant.id;
        let imageUrl = product.images && product.images.length > 0 ? product.images[0].src : "";

        if (numericId && imageUrl) {
          // Check if the URL already has query parameters to append correctly
          const formattedImageUrl = imageUrl.includes('?') ? `${imageUrl}&width=400` : `${imageUrl}?width=400`;

          products.push({
            id: numericId,
            title: product.title,
            image: formattedImageUrl
          });
        }
      });

      // Increment page to fetch the next batch in the next loop iteration
      page++; 

    } catch (error) {
      console.error(`Error fetching products.json for ${collectionHandle} on page ${page}:`, error);
      break; // Exit the loop if there's a network error
    }
  }

  return products;
}

// ==========================================
// 4. DYNAMIC DOM GENERATION (SCROLL SAFE)
// ==========================================
function buildModalDOM() {
  const existingModal = document.querySelector('.strap-modal-container');
  if (existingModal) existingModal.remove();

  const isSingleStepPromo = PROMO_CONFIG.steps.length === 1;
  
  const breadcrumbsHTML = PROMO_CONFIG.steps.map((step, index) => {
    const isFirst = index === 0;
    return `<span id="indicator-${step.id}" style="opacity: ${isFirst ? '1' : '0.5'}; text-decoration: ${isFirst ? 'underline' : 'none'}; transition: opacity 0.2s;">Step ${index + 1}: ${step.navTitle}</span>`;
  }).join(' &rsaquo; ');

  const breadcrumbsContainer = isSingleStepPromo ? '' : `
    <div class="modal-step-indicator" style="text-align: center; margin-bottom: 10px; margin-top: 15px; font-size: 14px; font-weight: bold; text-transform: uppercase;">
      ${breadcrumbsHTML}
    </div>
  `;

  const stepsHTML = PROMO_CONFIG.steps.map((step, index) => {
    const isFirst = index === 0;
    const isLast = index === PROMO_CONFIG.steps.length - 1;
    const displayStyle = isFirst ? '' : 'display: none;';
    const uiClass = `step-ui-${index}`; 
    const itemsData = window.modalData[step.dataKey];
    
    let gridItems = itemsData.map(item => `
      <div class="strap-item">
        <img src="${item.image}" alt="${item.title}">
        <span class="strap-label">${item.title}</span>
        <button class="select-btn btn btn--full btn--secondary" data-id="${item.id}" data-step-id="${step.id}" data-limit="${step.limit}" data-attached="false">SELECT</button>
      </div>
    `).join('');

    // Append 'Load All' button if configured
    if (step.target_collection_handle) {
      gridItems += `
        <div class="strap-item load-all-wrapper" style="display:flex; align-items:center; justify-content:center; padding: 20px;">
          <button class="btn btn--secondary load-all-btn" data-step-id="${step.id}" data-handle="${step.target_collection_handle}" data-datakey="${step.dataKey}">Load All ${step.navTitle}</button>
        </div>
      `;
    }

    let footerButtons = '';
    if (isFirst && isLast) {
      footerButtons = `
        <button id="btn-submit" class="btn btn--full atc-main-btn" disabled>ADD TO CART</button>
        <button type="button" class="btn btn--full" id="btn-auto-choose"><span>Choose for me</span></button>
      `;
    } else if (isFirst) {
      footerButtons = `
        <button id="btn-next-${step.id}" class="btn btn--full atc-main-btn step-nav-btn" data-target="${index + 1}" disabled>NEXT: ${PROMO_CONFIG.steps[index + 1].navTitle.toUpperCase()}</button>
        <button type="button" class="btn btn--full" id="btn-auto-choose"><span>Choose for me</span></button>
      `;
    } else if (isLast) {
      footerButtons = `
        <button class="btn btn--secondary step-nav-btn" data-target="${index - 1}" style="min-width: 100px;">&larr; BACK</button>
        <button id="btn-submit" class="btn btn--full atc-main-btn" style="" disabled>ADD TO CART</button>
      `;
    } else {
      footerButtons = `
        <button class="btn btn--secondary step-nav-btn" data-target="${index - 1}" style="flex: 1;">&larr; BACK</button>
        <button id="btn-next-${step.id}" class="btn btn--full atc-main-btn step-nav-btn" data-target="${index + 1}" style="" disabled>NEXT: ${PROMO_CONFIG.steps[index + 1].navTitle.toUpperCase()}</button>
      `;
    }

    return `
      <div class="modal-header ${uiClass}" style="${displayStyle}">
        <h2 class="modal-title">${step.headerTitle}</h2>
        <span class="pill" id="counter-${step.id}">0/${step.limit} Selected</span>
      </div>
      <div class="strap-grid ${uiClass}" style="${displayStyle}" id="grid-${step.id}">
        ${gridItems}
      </div>
      <div class="modal-footer ${uiClass}" style="${displayStyle} ${(index > 0) ? 'flex-wrap: wrap; gap: 10px;' : ''}">
        ${footerButtons}
      </div>
    `;
  }).join('');

  const modalHTML = `
    <div class="strap-modal-container">
      <div id="strap-modal" class="modal-overlay model-visible">
        <div class="modal-content">
          <span class="close-modal">&times;</span>
          ${breadcrumbsContainer}
          ${stepsHTML}
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
  attachModalEvents();
}

// ==========================================
// 5. MODAL LOGIC & EVENTS
// ==========================================
function openDynamicModal() {
  userSelections = {};
  PROMO_CONFIG.steps.forEach(step => userSelections[step.id] = []);
  currentStepIndex = 0;
  document.querySelector('button.drawer__close-button.js-drawer-close').click();
  buildModalDOM();
}

// Extracted handler so it can be applied to dynamically loaded items
function handleSelectClick(e) {
  const btn = e.currentTarget;
  const id = btn.getAttribute('data-id');
  const stepId = btn.getAttribute('data-step-id');
  const limit = parseInt(btn.getAttribute('data-limit'));
  
  const arr = userSelections[stepId];
  
  if (arr.includes(id)) {
    // Deselect
    arr.splice(arr.indexOf(id), 1);
    btn.classList.remove('selected');
    btn.innerText = 'SELECT';
  } else if (arr.length < limit) {
    // Select
    arr.push(id);
    btn.classList.add('selected');
    btn.innerText = 'SELECTED';
  }
  
  updateStepUI(stepId, limit);
}

function attachModalEvents() {
  document.querySelector('.close-modal')?.addEventListener('click', closeModal);
  document.querySelector('#strap-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'strap-modal') closeModal();
  });

  document.querySelectorAll('.step-nav-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      goToStep(parseInt(btn.getAttribute('data-target')));
    });
  });

  document.getElementById('btn-auto-choose')?.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.add('btn--loading');
    submitAutoSelections();
  });

  document.getElementById('btn-submit')?.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.add('btn--loading');
    submitManualSelections();
  });

  // Attach event to initial select buttons
  document.querySelectorAll('.select-btn[data-attached="false"]').forEach(btn => {
    btn.setAttribute('data-attached', 'true');
    btn.addEventListener('click', handleSelectClick);
  });

  // Attach "Load All" logic
  document.querySelectorAll('.load-all-btn').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const stepId = this.getAttribute('data-step-id');
      const handle = this.getAttribute('data-handle');
      const dataKey = this.getAttribute('data-datakey');
      const stepConfig = PROMO_CONFIG.steps.find(s => s.id === stepId);
      
      this.innerText = 'Loading...';
      this.disabled = true;

      // 1. Fetch all available products
      const allProducts = await getAllProducts(handle);
      
      // 2. Filter out items we've already loaded in the initial DOM
      const existingIds = new Set(window.modalData[dataKey].map(item => parseInt(item.id)));
      const newItems = allProducts.filter(item => !existingIds.has(item.id));
      
      // 3. Add to global state so auto-choose can access them if needed
      window.modalData[dataKey] = [...window.modalData[dataKey], ...newItems];

      // 4. Generate HTML for only the NEW items
      const newItemsHTML = newItems.map(item => `
        <div class="strap-item">
          <img src="${item.image}" alt="${item.title}">
          <span class="strap-label">${item.title}</span>
          <button class="select-btn btn btn--full btn--secondary" data-id="${item.id}" data-step-id="${stepId}" data-limit="${stepConfig.limit}" data-attached="false">SELECT</button>
        </div>
      `).join('');

      // 5. Insert directly into the grid before the load wrapper
      this.parentElement.insertAdjacentHTML('beforebegin', newItemsHTML);
      
      // 6. Bind events to the newly injected select buttons
      const grid = document.getElementById(`grid-${stepId}`);
      grid.querySelectorAll('.select-btn[data-attached="false"]').forEach(selectBtn => {
        selectBtn.setAttribute('data-attached', 'true');
        selectBtn.addEventListener('click', handleSelectClick);
      });
      
      // 7. Remove the "Load All" button to clean up the UI
      this.parentElement.remove();
    });
  });
}

function goToStep(targetIndex) {
  PROMO_CONFIG.steps.forEach((step, i) => {
    document.querySelectorAll(`.step-ui-${i}`).forEach(el => el.style.display = 'none');
    const ind = document.getElementById(`indicator-${step.id}`);
    if(ind) {
      ind.style.opacity = '0.5';
      ind.style.textDecoration = 'none';
    }
  });

  document.querySelectorAll(`.step-ui-${targetIndex}`).forEach(el => el.style.display = ''); 
  
  const targetStep = PROMO_CONFIG.steps[targetIndex];
  const targetInd = document.getElementById(`indicator-${targetStep.id}`);
  if (targetInd) {
    targetInd.style.opacity = '1';
    targetInd.style.textDecoration = 'underline';
  }
  
  currentStepIndex = targetIndex;
}

function updateStepUI(stepId, limit) {
  const count = userSelections[stepId].length;
  
  const counterPill = document.getElementById(`counter-${stepId}`);
  if (counterPill) counterPill.innerText = `${count}/${limit} Selected`;

  const stepIndex = PROMO_CONFIG.steps.findIndex(s => s.id === stepId);
  const isLast = stepIndex === PROMO_CONFIG.steps.length - 1;
  
  if (isLast) {
    const submitBtn = document.getElementById('btn-submit');
    if (submitBtn) submitBtn.disabled = (count < limit);
  } else {
    const nextBtn = document.getElementById(`btn-next-${stepId}`);
    if (nextBtn) {
      if (count === limit) {
        nextBtn.disabled = false;
        nextBtn.innerText = `NEXT: ${PROMO_CONFIG.steps[stepIndex + 1].navTitle.toUpperCase()}`;
      } else {
        nextBtn.disabled = true;
        nextBtn.innerText = `SELECT ${limit - count} MORE ${PROMO_CONFIG.steps[stepIndex].navTitle.toUpperCase()}`;
      }
    }
  }
}

function closeModal() {
  document.querySelector('.strap-modal-container')?.remove();
  fallbackToCart();
}

// ==========================================
// 6. CART SUBMISSIONS
// ==========================================
function submitManualSelections() {
  const bundleId = getBundleId();
  const allSelectedIds = Object.values(userSelections).flat();
  const items = allSelectedIds.map(id => ({ 
    id: parseInt(id), 
    quantity: 1,
    properties: {
      _bundle_id: bundleId
    }
  }));
  
  processCartAdd(items);
}

function submitAutoSelections() {
  const items = [];
  const bundleId = getBundleId();
  PROMO_CONFIG.steps.forEach(step => {
    const dataArray = window.modalData[step.dataKey];
    const topPicks = dataArray.slice(0, step.limit);
    topPicks.forEach(item => {
      items.push({ 
        id: parseInt(item.id), 
        quantity: 1,
        properties: {
          _bundle_id: bundleId
        }
      });
    });
  });
  
  processCartAdd(items);
}

function processCartAdd(itemsArray) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itemsArray })
  })
  .then(res => res.json())
  .then(() => {
    closeModal();
    resetBundleIdField();
  })
  .catch(err => {
    console.error("Cart Error:", err);
    closeModal();
    resetBundleIdField();
  });
}

// ==========================================
// 7. MAIN PRODUCT ADD TO CART TRIGGERS
// ==========================================
document.querySelectorAll('[data-new-atc], [data-sticky-atc]').forEach(button => {
  button.addEventListener('click', async function(e) {
    e.preventDefault(); 
    const btn = this;
    const mainVariantId = this.getAttribute('data-variant-id');
    const freeGiftId = btn.getAttribute('data-free-gift-id');
    const productHandle = btn.getAttribute('data-product-handle') || null;
    const bundleId = getBundleId();
    if (!mainVariantId) return console.error("Variant ID missing");

    btn.classList.add('btn--loading');
    this.style.pointerEvents = 'none';

    try {
        let items = [{ 
          id: parseInt(mainVariantId), 
          quantity: 1,
          properties: {
            _bundle_id: bundleId 
          }
        }];

        if (freeGiftId) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const giftAlreadyInCart = cart.items.some(item => item.id === parseInt(freeGiftId));

          if (!giftAlreadyInCart) {
            items.push({ id: parseInt(freeGiftId), quantity: 1 });
          }
        }

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        await fetchStrapData(productHandle);

    } catch (error) {
        console.error('Error:', error);
    } finally {
        btn.classList.remove('btn--loading');
        btn.style.pointerEvents = 'auto';
    }
  });
});

// ==========================================
// 8. PROMO BANNER INJECTION
// ==========================================
const targetElement = document.querySelector('[data-new-atc]');
const textEl = document.querySelector('#AnnouncementSlider');

if (targetElement && textEl) {
  const text = textEl.innerText;
  const match = text.match(/WORTH\s+([^\s]+)/i);
  let worthString = match ? ` WORTH ${match[1]}` : "";

  const promoBanner = promoBannerTemplate.replaceAll('#worthString#', worthString);
  targetElement.insertAdjacentHTML('beforebegin', promoBanner);
}

// ==========================================
// 9. CART PAGE VALIDATION 
// ==========================================
async function checkCartForMissingGifts() {
  if (window.location.pathname !== '/cart') return;

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    if (cart.items.length === 0) return;

    const qualifyingBags = cart.items.filter(item => {
      const isBag = /\bbag(s)?\b/i.test(item.title) || /\bbag(s)?\b/i.test(item.title);
      
      const excludeRegex = /\b(strand|pelham|travel|weekend|lulworth)\b/i;
      const isExcluded = excludeRegex.test(item.title) || excludeRegex.test(item.handle);
      
      return isBag && !isExcluded;
    });

    if (qualifyingBags.length === 0) return; 

    const mainBagHandle = qualifyingBags[0].handle;

    let existingStrapsCount = 0;
    let existingPursesCount = 0;

    cart.items.forEach(item => {
      if (item.price === 0) {
        if (/\bstrap(s)?\b/i.test(item.title) || /\bstrap(s)?\b/i.test(item.title)) {
          existingStrapsCount += item.quantity;
        }
        if (/\bpurse(s)?\b/i.test(item.title) || /\bpurse(s)?\b/i.test(item.title)) {
          existingPursesCount += item.quantity;
        }
      }
    });

    const strapConfig = PROMO_CONFIG.steps.find(s => s.id === 'strap');
    const purseConfig = PROMO_CONFIG.steps.find(s => s.id === 'purse');
    
    const requiredStraps = strapConfig ? strapConfig.limit : 0;
    const requiredPurses = purseConfig ? purseConfig.limit : 0;

    if (existingStrapsCount < requiredStraps || existingPursesCount < requiredPurses) {
      await fetchStrapData(mainBagHandle);
    }

  } catch (error) {
    console.error("Error validating cart gifts:", error);
  }
}
document.addEventListener('DOMContentLoaded', checkCartForMissingGifts);